export default "__VITE_ASSET__pljaGrp3__"